module.exports = __webpack_public_path__ + "static/img/avatar-06.99afd8a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/profiles/avatar-06.jpg
// module id = xuCh
// module chunks = 22